export default "__VITE_ASSET__ml2z0qyK__"